import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { oneadvancedApiRef } from './api/OneAdvancedApi';
import { OneAdvancedClient } from './api/OneAdvancedClient';

export const oneadvancedPlugin = createPlugin({
  id: 'oneadvanced',
  apis: [
    createApiFactory({
      api: oneadvancedApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new OneAdvancedClient({ discoveryApi, fetchApi }),
    }),
  ],
});
